

export class RequestServiceModel {
    id: number;
    lotNumber: number;
    wrTypeCD: string;
    applicantContactName1: string;
    applicantContactName2: string;
    applicantEmail: string;
    applicantPhoneNumber: string;
    applicantPhoneExtension: string;
    applicantStreetNo: number;
    applicantStreetName: string;
    applicantStreetType: string;
    applicantDirectionPrefix: string;
    applicantUnitNo: string;
    applicantDirectionSuffix: string;
    applicantAddress2: string;
    applicantCity: string;
    applicantState: string;
    applicantZip: string;
    deliveryPressure: string;
    plumberCompanyName: string;
    plumberContactName: string;
    plumberContactNo: string;
    developmentName: string;
    serviceNeededBy: Date;
    plannedDt: Date;
    installedDTTM: Date;
    heatedSquareFootage: number;
    lotStatus: string;
    countyId: string;
    builderId: string;
    stateCd: string;
    address: string;
    grId: number;
    streetNo: number;
    streetName: string;
    city: string;
    zip: string;
    wrSummaryId: number;
    subDivision: string;
    unitNo: string;
    originalBd: string;
    checked: boolean;
    originalCName: string;
    builderCName: string;
  otherDeliveryPressure: string;
  statusDesc: string;
  recCreateDttm: string;
  recCreateUsrId: string;
  recUpdateDttm: string;
  recUpdateUsrId: string;
  isManualLotRequested: string;
  lotStatusUpdatedBy: string;
  lotStatusUpdatedDate: string;
   }

   export class GasApplianceModel {
    id: number;
    applianceCd: string;
    applianceDesc: string;
    quantity: number;
    loadValue: number;
    recCreatedBy: string;
    recCreatedDttm: string;
    recUpdatedBy: string;
    recUpdatedDttm: string;
    wrSummaryId: number;
    applianceOthers: string;
   }
